import { statusesAction, StatusActionTypes } from "../../types/status";
import { Dispatch } from "react";
import http from "../../utils/http-common";

export const getStatuses = () => {
  return async (dispatch: Dispatch<statusesAction>): Promise<void> => {
    try {
      dispatch({
        type: StatusActionTypes.GET_STATUSES,
      });

      const response = await http.get(`/api/v0.1/validation/status`);
      dispatch({
        type: StatusActionTypes.GET_STATUSES_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: StatusActionTypes.GET_STATUSES_ERROR,
        payload: "Произошла ошибка получения статусов",
      });
    }
  };
};
